import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // Get all users
    getUsers: (nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/users/` +
                `${nbItems}/${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Create a new user
    createUser: username => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/users`)
                .set('x-access-token', credentials)
                .send({
                    username,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete user
    deleteUser: username => {
        const credentials = getCredentialsFromLocalStorage();


        return new Promise((resolve, reject) => {
            request
                .delete(`${apiUrlProvider.apiUrl()}/iam/user/${username}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // authenticate user
    login: (username, password) => (
        new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/authenticate`)
                .send({
                    username,
                    password,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        })
    ),

};



/** WEBPACK FOOTER **
 ** ./src/utils/UsersAPI.js
 **/